import { jsx } from "react/jsx-runtime";
import InsertInvitationOutlinedIcon from "@mui/icons-material/InsertInvitationOutlined";
import { validateTidalLicense } from "../../base/index.js";
function InsertInvitationOutlined(props) {
  return /* @__PURE__ */ jsx(
    InsertInvitationOutlinedIcon,
    {
      "data-testid": "InsertInvitationOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "InsertInvitationOutlined",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
InsertInvitationOutlined.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "InsertInvitationOutlined"
};
validateTidalLicense();
export {
  InsertInvitationOutlined
};
//# sourceMappingURL=InsertInvitationOutlined.js.map
